module.exports = __webpack_public_path__ + "img/14950a1.png";